module.exports = __webpack_public_path__ + "img/proyecto_home3.d1892223.png";